var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SegmentedToggleComponentBuilder_instances, _SegmentedToggleComponentBuilder_positiveButtonId, _SegmentedToggleComponentBuilder_negativeButtonId, _SegmentedToggleComponentBuilder_withButton;
import { ComponentType } from '../types';
import { AbstractComponentBuilder } from './AbstractComponentBuilder';
export class SegmentedToggleComponentBuilder extends AbstractComponentBuilder {
    constructor(id) {
        super(id, ComponentType.SegmentedToggle);
        _SegmentedToggleComponentBuilder_instances.add(this);
        _SegmentedToggleComponentBuilder_positiveButtonId.set(this, 'positive');
        _SegmentedToggleComponentBuilder_negativeButtonId.set(this, 'negative');
        this.patch({
            buttons: [
                { id: 'positive', displayName: '' },
                { id: 'negative', displayName: '' },
            ],
        });
    }
    setPositiveLabel(label) {
        return __classPrivateFieldGet(this, _SegmentedToggleComponentBuilder_instances, "m", _SegmentedToggleComponentBuilder_withButton).call(this, __classPrivateFieldGet(this, _SegmentedToggleComponentBuilder_positiveButtonId, "f"), label);
    }
    setNegativeLabel(label) {
        return __classPrivateFieldGet(this, _SegmentedToggleComponentBuilder_instances, "m", _SegmentedToggleComponentBuilder_withButton).call(this, __classPrivateFieldGet(this, _SegmentedToggleComponentBuilder_negativeButtonId, "f"), label);
    }
    isValid() {
        const { buttons } = this.state();
        const ids = new Set(buttons.map((button) => button.id));
        const validation = this.createValidationResponse()
            .withParentValidation(super.isValid())
            .withCheck('should be defined both positive and negative buttons', () => {
            return (ids.size === 2 &&
                ids.has(__classPrivateFieldGet(this, _SegmentedToggleComponentBuilder_positiveButtonId, "f")) &&
                ids.has(__classPrivateFieldGet(this, _SegmentedToggleComponentBuilder_negativeButtonId, "f")));
        });
        return validation.validate();
    }
}
_SegmentedToggleComponentBuilder_positiveButtonId = new WeakMap(), _SegmentedToggleComponentBuilder_negativeButtonId = new WeakMap(), _SegmentedToggleComponentBuilder_instances = new WeakSet(), _SegmentedToggleComponentBuilder_withButton = function _SegmentedToggleComponentBuilder_withButton(id, displayName) {
    const state = this.state();
    this.patch({
        buttons: state.buttons.map((button) => button.id === id ? { id: button.id, displayName } : button),
    });
    return this;
};
//# sourceMappingURL=SegmentedToggleComponentBuilder.js.map